import { useCallback, useState } from 'react';
import { useStep } from './stepper.service';
const StepperStep = ({ render, step, icon, label, invalid = false, loading = false, disabled = false, hideControl = false, }) => {
    const [invalidState, setInvalidState] = useState(invalid);
    const [loadingState, setLoadingState] = useState(loading);
    const setState = useCallback((s) => {
        if (s.invalid !== undefined)
            setInvalidState(s.invalid);
        if (s.loading !== undefined)
            setLoadingState(s.loading);
    }, []);
    const { current, setNext, setPrevious, isSubmitting } = useStep({
        step,
        icon,
        label,
        hideControl,
        disabled,
        invalid: invalidState || invalid,
        loading: loadingState || loading,
    });
    if (current !== step)
        return null;
    const noop = () => { };
    const safeSetNext = setNext ?? noop;
    const safeSetPrevious = setPrevious ?? noop;
    return render({ setState, setNext: safeSetNext, setPrevious: safeSetPrevious, isSubmitting });
};
export default StepperStep;
